import BasicLayout from "../../layout/curr.vue"
// const pre = ' - 极客轻商城系统';
const meta = {
    auth: true
};

export default {
    path: 'order',
    name: 'order',
    component: BasicLayout,
    children: [{
            path: 'list',
            name: "order-list",
            component: () => import("@/pages/admin/order/list.vue"),
            meta: {
                ...meta,
                title: '订单管理 - 极客商城系统'
            }
        },
        {
            path: 'statistics',
            name: "order-statistics",
            component: () => import("@/pages/admin/order/statistics.vue"),
            meta: {
                ...meta,
                title: '订单统计 - 极客商城系统'
            }
        },
        {
          path: "*",
          redirect: '/home'
        },

    ]
};